// Reused across calls: creating a canvas element per measurement dominates the cost when a caller
// measures a whole list of labels, and `measureText` depends only on the `font` set below.
let measuringCanvas;

// The canvas 2d default, per spec. Assigning an unparseable value to `context.font` is ignored
// rather than reset, so on a shared canvas a falsy `font` would measure in whatever the previous
// caller set. Callers do pass one: `MultiSelectAutoComplete` measures with `''` until its ref
// attaches, and browsers that do not resolve the `font` shorthand in `getComputedStyle` (Firefox)
// hand every caller `''`.
const DEFAULT_CANVAS_FONT = '10px sans-serif';

export function getTextWidth(text, font) {
  measuringCanvas = measuringCanvas ?? document.createElement('canvas');
  const context = measuringCanvas.getContext('2d');
  context.font = font || DEFAULT_CANVAS_FONT;
  return context.measureText(text).width;
}
